import e from "react";
import { getIconColor as v } from "./iconfont.es5470.js";
import p from "./iconfont.es5471.js";
const h = {
  display: "block"
}, E = ({ size: a = 16, useVw: t, useRem: c, color: n, withColor: d, removeClassName: l, disableSSR: r, style: o, ...i }) => {
  const m = o ? { ...h, ...o } : h;
  return /* @__PURE__ */ e.createElement(p, { disableSSR: r }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-2024nianduzhangdan", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), height: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: m, fill: "none", ...i }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: l ? "" : "32px-2024å¹´åº¦è´¦å"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: l ? "" : "normal",
        fill: d ? v(n, 0, "#262933") : "#262933",
        datafollowfill: d ? v(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3.8 9.213A5.413 5.413 0 0 1 9.213 3.8h10.174A5.413 5.413 0 0 1 24.8 9.213V12.8a1 1 0 1 1-2 0V9.213A3.413 3.413 0 0 0 19.387 5.8H9.213A3.413 3.413 0 0 0 5.8 9.213v13.24a3.413 3.413 0 0 0 3.413 3.413H9.3a1 1 0 0 1 0 2h-.087A5.413 5.413 0 0 1 3.8 22.453V9.213Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M6.8 13.233a5.18 5.18 0 0 0 .871 1.729l.894-.083.649-.931-.798-2.402-1.035-.34-.575.342c.046-.912.335-1.76.805-2.48l.266.618 1.032.338L11 8.504v-1.09l-.504-.442A5.006 5.006 0 0 1 11.8 6.8h4.609a6.783 6.783 0 0 1 2.191 5 6.774 6.774 0 0 1-1.752 4.556A6.783 6.783 0 0 1 11.8 18.6a6.782 6.782 0 0 1-5-2.191v-3.176Zm5 3.767c-.607 0-1.19-.104-1.73-.295l-.203-.896.65-.933h2.565l.65.933-.2.896A5.192 5.192 0 0 1 11.8 17Zm1.123-3.724h-2.246l-.685-2.062L11.8 9.901l1.807 1.313-.684 2.062Zm1.767-3.252-2.09-1.52v-1.09l.683-.6a5.21 5.21 0 0 1 2.8 2.036l-.36.835-1.033.338Zm.493 1.522 1.036-.34.78.463a5.2 5.2 0 0 1-1.07 3.293l-.895-.083-.649-.932.798-2.401Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12.034 20.483c.341-.314.87-.483 1.378-.483.506 0 .965.124 1.32.439.343.303.569.767.569 1.413 0 .583-.187 1.253-.457 1.745l-1.753 3.202h2.21v1.234h-3.767v-1.104l2.041-3.788c.174-.311.318-.784.318-1.333 0-.204-.057-.347-.14-.437a.448.448 0 0 0-.341-.137.49.49 0 0 0-.355.135c-.088.087-.15.226-.15.428v.6H11.5v-.556c0-.645.192-1.043.534-1.358Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M16.596 20.483c.341-.314.846-.483 1.367-.483.522 0 1.014.17 1.355.483.341.314.545.711.545 1.358v4.438c0 .647-.204 1.044-.545 1.358-.34.313-.833.483-1.355.483-.521 0-1.026-.17-1.367-.483-.34-.314-.545-.711-.545-1.358v-4.438c0-.647.204-1.044.545-1.358Zm1.012.886c-.088.087-.15.226-.15.428v4.526c0 .202.062.34.15.428a.489.489 0 0 0 .355.135.471.471 0 0 0 .348-.134c.085-.087.145-.226.145-.43v-4.525c0-.203-.06-.342-.145-.43a.471.471 0 0 0-.348-.134.49.49 0 0 0-.355.136Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M22.56 20c-.51 0-1.037.169-1.379.483-.342.315-.534.713-.534 1.358v.557h1.408v-.6c0-.203.062-.342.15-.43a.49.49 0 0 1 .354-.134c.142 0 .259.048.341.137.083.09.14.233.14.437 0 .55-.143 1.022-.317 1.333l-2.041 3.788v1.104h3.767v-1.234h-2.21l1.753-3.202c.27-.492.456-1.162.456-1.745 0-.646-.226-1.11-.569-1.413-.354-.315-.814-.439-1.32-.439Zm4.55.087h1.386l-2.017 5.505h.77V24.21h1.409v1.382h.558v1.233h-.558v1.208H27.25v-1.208h-2.256v-1.152l2.116-5.586Z"
        }
      )
    )
  )));
}, g = E;
export {
  g as default
};
